export default __webpack_public_path__ + "f8aa7ca97dc88e1663b54bb20e19fcca.png";